import React, { PureComponent } from "react";
import { Row, Col } from "antd";
import { AccountCardComponent } from "../CardComponent/CardComponent";
import { PropTypes } from "prop-types";
import { replaceSelect } from "../../../../../utils/replacer"

export default class InvestmentAllocationTable extends PureComponent {
  render() {
    let PortfolioSolutionDetails =
      this.props.isAccountSummaryLoading === true ? (
        <div>
          <div className="loader-position-table"></div>
        </div>
      ) : this.props.data ? (
        this.props.data.map((data, i) => {
          return (
            <AccountCardComponent key={i}>
              <Row>
                <div className="poolName">{replaceSelect(data.poolName)}</div>
                <Col md={{ span: 8 }} xs={{ span: 6 }}>
                  <div>Price</div>
                  <div>
                    {"$" +
                      Number(data.pricePerUnit).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                  </div>
                </Col>
                <Col md={{ span: 8 }} xs={{ span: 9 }}>
                  <div>Units</div>
                  <div>
                    {Number(data.availableUnits).toLocaleString(undefined, {
                      minimumFractionDigits: 4,
                      maximumFractionDigits: 4
                    })}
                  </div>
                </Col>
                <Col md={{ span: 8 }} xs={{ span: 9 }}>
                  <div>Market Value</div>
                  <div>
                    {"$" +
                      Number(data.currentBalance).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                  </div>
                </Col>
              </Row>
            </AccountCardComponent>
          );
        })
      ) : (
        <AccountCardComponent className="noDataPlacement-table">
          <div>No data found.</div>
        </AccountCardComponent>
      );
    return <div>{PortfolioSolutionDetails}</div>;
  }
}
InvestmentAllocationTable.propTypes = {
  data: PropTypes.array
};
